
import {Options, Vue} from 'vue-class-component';
import './../less/index.less'
import Gallery from "@/components/Gallery.vue";
import RegistrationForm from './RegistrationForm.vue';
import Logo from "@/components/Logo.vue";

@Options({
    components: {
        Gallery,
        Logo,
        RegistrationForm,
    },
})
export default class IndexPage extends Vue {
    isOpenMenu = false

    menuToggle() {
        this.isOpenMenu = !this.isOpenMenu
    }

    goToRegistrationForm() {
        window.location.hash = 'registrationForm'
    }

    beforeMount() {
        document.title = 'Hungarian Business Awards – A megérdemelt üzleti elismerés!'
    }

    mounted() {
        document.title = 'Hungarian Business Awards – A megérdemelt üzleti elismerés!'
    }
}
